module.exports = __webpack_public_path__ + "static/lady_laptop-0e639a257fd3d027b524f60c65a34d2f.svg";